import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, effect, inject } from '@angular/core';
import { AbstractBasketComponent } from '@df/basket/abstract-basket.component';
import { BasketItem } from '@df/session/api/basket/basket-item';
import sumBy from 'lodash-es/sumBy';
import { BranchService } from '../../branch/branch.service';
import { NCmsBranchCollection } from '../../branch/collection/branch-collection.component';
import { TradeService } from '../../checkout/module/trade/trade.service';
import { DeliveryPostcodeService } from '../../common/delivery/delivery-postcode.service';
import { NCmsDelivery } from '../../common/delivery/modal/delivery-modal.component';
import { NBasketViewCms } from './basket-view-cms.component';

interface SplitedBasketElement {
    isCollection: boolean;
    name: string;
    items: BasketItem[];
    subtotal: number;
    modalId: string;
    qty: number;
}

declare module '@tomandco/nexus-api-types' {
    namespace Nexus.Lib.Basket {
        interface BasketItem {
            isCollection?: boolean | 'false' | 'true';
        }
    }
}

@Component({
    selector: 'basket-view',
    templateUrl: './basket-view.html',
    styleUrls: ['./basket-view.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketViewComponent extends AbstractBasketComponent implements OnDestroy, OnInit {
    @Input()
    content?: NBasketViewCms.IBlockDataContent;

    splitedBasket: SplitedBasketElement[] = [
        { isCollection: false, name: 'Delivery to', items: [], subtotal: 0, qty: 0, modalId: NCmsDelivery.MODAL_ID },
        { isCollection: true, name: 'Collection from', items: [], subtotal: 0, qty: 0, modalId: NCmsBranchCollection.MODAL_ID }
    ];
    protected deliveryPostcodeService = inject(DeliveryPostcodeService);
    protected branchService = inject(BranchService);

    private tradeService = inject(TradeService);

    constructor() {
        super();
        effect(() => {
            this.branchService.branchNumber();
            this.detectChanges();
        });
        effect(() => {
            this.deliveryPostcodeService.postcode();
            this.detectChanges();
        });
    }

    get branchName(): string {
        return this.branchService.branchNumber() ? this.branchService.toName(this.branchService.branchNumber() || 0) : '';
    }

    protected get splitedBasketQty(): number {
        return sumBy(this.splitedBasket, 'qty');
    }

    override ngOnInit(): void {
        this.subscriptions.add(
            this.basket.subscribe(() => {
                this.updateBasketSplit();
            })
        );
        this.updateBasketSplit();
        this.loadBranchName();

        super.ngOnInit();
    }

    async loadBranchName(): Promise<void> {
        if (await this.branchService.load()) {
            this.detectChanges();
        }
    }

    protected itemTrackFn(index: number, item: BasketItem): number {
        return item.id;
    }

    private updateBasketSplit(): void {
        this.splitedBasket[0].items = this.basket.items.filter(i => i.data.isCollection === 'false' || !i.data.isCollection);
        this.splitedBasket[1].items = this.basket.items.filter(i => i.data.isCollection === 'true' || i.data.isCollection === true);
        this.splitedBasket.forEach(baskteSplited => {
            baskteSplited.qty = sumBy(baskteSplited.items, 'qty');
            baskteSplited.subtotal = sumBy(baskteSplited.items, 'data.rowPrice');
        });
    }
}
